import { withSentryReactRouterV6Routing } from '@sentry/react';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { GlobalRedirectGate } from './GlobalRedirectGate';
import { RequireRnsSession } from './RequireRnsSession';
import { VrsTeamingLogoutNoticeRoute } from './VrsTeamingLogoutNoticeRoute';

import { LoadingPortal } from 'features/app-loading/components';
import { VrsCallSurvey } from 'features/call/vrs-call/components';
import { MultiMode } from 'features/multi-mode/components';
import { PageRoute } from 'features/router/routes';

const MainContainer = lazy(() => import('./MainContainer'));
const DashboardPage = lazy(() => import('pages/DashboardPage/DashboardPage'));
const VriCallPage = lazy(() => import('pages/VriCallPage/VriCallPage'));
const VrsCallPage = lazy(() => import('pages/VrsCallPage/VrsCallPage'));
const VriConferenceCallPage = lazy(
  () => import('pages/VriConferenceCallPage/VriConferenceCallPage')
);
const VrsConferenceCallPage = lazy(
  () => import('pages/VrsConferenceCallPage/VrsConferenceCallPage')
);
const ZoomPageVrs = lazy(() => import('pages/VrsZoomPage/VrsZoomPage'));
const ZoomPageVri = lazy(() => import('pages/VriZoomPage/VriZoomPage'));
const InCenterTeamingNoticePage = lazy(
  () => import('pages/teaming-notice/InCenterTeamingNoticePage')
);
const AccessDeniedPage = lazy(() => import('pages/error/AccessDeniedPage'));
const NotFoundPage = lazy(() => import('pages/error/NotFoundPage'));
const SomethingWentWrongPage = lazy(
  () => import('pages/error/SomethingWentWrongPage')
);
const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export const Router = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingPortal />}>
        <SentryRoutes>
          <Route element={<GlobalRedirectGate />}>
            <Route
              path={PageRoute.VRS_IN_CENTER_TEAMING_NOTICE}
              element={<InCenterTeamingNoticePage />}
            />
            <Route
              path={PageRoute.VRS_TEAMING_LOGOUT_NOTICE}
              element={<VrsTeamingLogoutNoticeRoute />}
            />

            <Route path={PageRoute.MAIN} element={<MultiMode />}>
              <Route element={<MainContainer />}>
                <Route index element={<DashboardPage />} />
                <Route
                  path={PageRoute.VRI_CALL}
                  element={
                    <RequireRnsSession>
                      <VriCallPage />
                    </RequireRnsSession>
                  }
                />

                <Route
                  path={PageRoute.VRI_CONFERENCE}
                  element={<VriConferenceCallPage />}
                />

                <Route
                  path={PageRoute.VRS_CALL}
                  element={
                    <RequireRnsSession>
                      <VrsCallPage />
                    </RequireRnsSession>
                  }
                />

                <Route
                  path={PageRoute.VRS_CONFERENCE}
                  element={<VrsConferenceCallPage />}
                />
              </Route>

              <Route path={PageRoute.ZOOM_VRS} element={<ZoomPageVrs />} />
              <Route path={PageRoute.ZOOM_VRI} element={<ZoomPageVri />} />
            </Route>

            <Route
              path={PageRoute.REPORT_PREVIOUS_CALL}
              element={<VrsCallSurvey />}
            />
            <Route
              path={PageRoute.SOMETHING_WENT_WRONG}
              element={<SomethingWentWrongPage />}
            />
            <Route
              path={PageRoute.ACCESS_DENIED}
              element={<AccessDeniedPage />}
            />
            <Route path='*' element={<NotFoundPage />} />
          </Route>
        </SentryRoutes>
      </Suspense>
    </BrowserRouter>
  );
};
